import { useCompetitionLevelListQuery } from '~/pages/level/queries';
import { Input, SelectProps } from '~/components/Input';
import { BaseFormState } from '~/types/BaseFormState';
import { ForwardedRef, forwardRef } from 'react';
import { HasStyle } from '~/types/HasStyle';

type Props<TFormState extends BaseFormState> = Omit<SelectProps<TFormState>, 'options'> & HasStyle;

function CompetitionCategorySelectElement<TFormState extends BaseFormState>(
  props: Props<TFormState>,
  ref: ForwardedRef<HTMLSelectElement>
) {
  const { data = [], isLoading } = useCompetitionLevelListQuery();

  return (
    <Input.Select
      placeholder={props.placeholder ?? 'Alla tävlingsnivåer'}
      options={data.map(o => [o.description, o.name])}
      aria-label="Tävlingsnivå"
      disabled={isLoading}
      ref={ref}
      {...props}
    />
  );
}

export const CompetitionCategorySelect = forwardRef(CompetitionCategorySelectElement) as <
  TFormState extends BaseFormState,
>(
  props: Props<TFormState> & { ref?: React.ForwardedRef<HTMLSelectElement> }
) => ReturnType<typeof CompetitionCategorySelectElement>;
